/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ForgotPasswordValidationRequest } from '../models/forgot-password-validation-request';


/**
 * API for forgot password validation.
 */
@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation validateForgotPassword
   */
  static readonly ValidateForgotPasswordPath = '/forgot-password/{tenantId}/validate';

  /**
   * Validate forgot password request.
   *
   * Initiates a password reset if the user exists and is active. Always returns 204 to prevent email enumeration.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateForgotPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateForgotPassword$Response(params: {

    /**
     * The unique identifier of the tenant
     */
    tenantId: string;
    body: ForgotPasswordValidationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ForgotPasswordService.ValidateForgotPasswordPath, 'post');
    if (params) {
      rb.path('tenantId', params.tenantId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Validate forgot password request.
   *
   * Initiates a password reset if the user exists and is active. Always returns 204 to prevent email enumeration.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateForgotPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  validateForgotPassword(params: {

    /**
     * The unique identifier of the tenant
     */
    tenantId: string;
    body: ForgotPasswordValidationRequest
  },
  context?: HttpContext

): Observable<{
}> {

    return this.validateForgotPassword$Response(params,context).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

}
